import { IoMdRadioButtonOff, IoMdRadioButtonOn } from "react-icons/io"

export default function SetupAndDemoApplication({ setApplicationState, applicationPiece }) {
  return (
    <>
      <h5>Course Commencement Date</h5>
      <p>When are you planning to start?</p>
      <div className="intended-learners-wr">
        <input onChange={(e)=>{setApplicationState(prev=>({...prev, coursePlan: {...prev.coursePlan, courseCommencementDate: e.target.value}}))}} value={applicationPiece.courseCommencementDate}  type="date" />
      </div>
      <h5> Calendly Link (Optional)</h5>
      <p>Using this link students can schedule a 1:1 meet with you in case of doubts</p>
      <div className="intended-learners-wr">
        <input onChange={(e)=>{setApplicationState(prev=>({...prev, coursePlan: {...prev.coursePlan, calendlyLinkOptional: e.target.value}}))}} value={applicationPiece.calendlyLinkOptional} placeholder="Example: calendly link" type="text" />
      </div>
      <h5>Course Brochure (Optional)</h5>
      <p>Upload a brochure for your course</p>
      <div className="intended-learners-wr">
        <input onChange={(e)=>{setApplicationState(prev=>({...prev, coursePlan: {...prev.coursePlan, courseBrochure: e.target.files[0]}}))}} type="file" />
      </div>
      <h5>Demo Lecture URL(Optional)</h5>
      <p>Give them a taste of your course</p>
      <div className="intended-learners-wr">
      <input onChange={(e)=>{setApplicationState(prev=>({...prev, coursePlan: {...prev.coursePlan, demoLectureURL: e.target.value}}))}} value={applicationPiece.demoLectureURL} placeholder="Example: https://youtu.be/my-course-demo" type="text" />
      </div>
    </>
  )
}